/**
 * Midnight Express LKN - Google Reviews Carousel
 *
 * Fetches reviews via Google Apps Script proxy, caches locally,
 * and renders an auto-rotating Slick carousel of testimonial cards.
 */

(function($) {
    "use strict";

    // =================================================================
    // CONFIGURATION
    // =================================================================

    const REVIEWS_API_URL = process.env.REVIEWS_API_URL;
    const CACHE_KEY = 'melkn_reviews';
    const CACHE_TTL_MS = 6 * 60 * 60 * 1000; // 6 hours
    const MIN_RATING = 4;

    // =================================================================
    // CACHE
    // =================================================================

    function getCachedReviews() {
        try {
            var cached = localStorage.getItem(CACHE_KEY);
            if (!cached) return null;
            var data = JSON.parse(cached);
            if (Date.now() - data.timestamp > CACHE_TTL_MS) {
                localStorage.removeItem(CACHE_KEY);
                return null;
            }
            return data.reviews;
        } catch (e) {
            return null;
        }
    }

    function setCachedReviews(reviews) {
        try {
            localStorage.setItem(CACHE_KEY, JSON.stringify({
                timestamp: Date.now(),
                reviews: reviews
            }));
        } catch (e) {
            // localStorage full or unavailable — ignore
        }
    }

    // =================================================================
    // RENDERING
    // =================================================================

    function renderStars(rating) {
        var html = '';
        for (var i = 0; i < 5; i++) {
            html += '<i class="fa fa-star' + (i < rating ? '' : '-o') + '"></i>';
        }
        return html;
    }

    function getRelativeTime(dateString) {
        var now = new Date();
        var then = new Date(dateString);
        var diffMs = now - then;
        var diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

        if (diffDays < 1) return 'today';
        if (diffDays === 1) return 'yesterday';
        if (diffDays < 7) return diffDays + ' days ago';
        if (diffDays < 30) return Math.floor(diffDays / 7) + ' week' + (Math.floor(diffDays / 7) > 1 ? 's' : '') + ' ago';
        if (diffDays < 365) return Math.floor(diffDays / 30) + ' month' + (Math.floor(diffDays / 30) > 1 ? 's' : '') + ' ago';
        return Math.floor(diffDays / 365) + ' year' + (Math.floor(diffDays / 365) > 1 ? 's' : '') + ' ago';
    }

    function truncateText(text, maxLength) {
        if (!text || text.length <= maxLength) return text || '';
        return text.substring(0, maxLength).replace(/\s+\S*$/, '') + '...';
    }

    function escapeAttr(str) {
        return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function renderCard(review) {
        var text = review.text || '';
        var truncated = truncateText(text, 200);
        var needsMore = text.length > 200;

        return '<div class="review-card">' +
            '<div class="review-quote"><i class="fa fa-quote-left"></i></div>' +
            '<div class="review-stars">' + renderStars(review.rating) + '</div>' +
            '<p class="review-text">' +
                '<span class="review-text-short">' + $('<span>').text(truncated).html() + '</span>' +
                (needsMore ? '<span class="review-text-full" style="display:none;">' + $('<span>').text(text).html() + '</span>' +
                    ' <a href="#" class="review-read-more">read more</a>' : '') +
            '</p>' +
            '<div class="review-author">' +
                '<span class="review-author-name">' + review.authorName + '</span>' +
                '<span class="review-time">' + getRelativeTime(review.createTime) + '</span>' +
            '</div>' +
        '</div>';
    }

    function renderReviews(reviews) {
        var $container = $('#reviews-container');
        var html = '';

        reviews.forEach(function(review) {
            html += renderCard(review);
        });

        $container.html(html);

        $container.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: true,
            arrows: true,
            dots: true,
            responsive: [
                { breakpoint: 992, settings: { slidesToShow: 2 } },
                { breakpoint: 768, settings: { slidesToShow: 1 } }
            ]
        });

        // Handle "read more" / "show less" clicks
        $container.on('click', '.review-read-more', function(e) {
            e.preventDefault();
            var $link = $(this);
            var $p = $link.closest('.review-text');
            var $short = $p.find('.review-text-short');
            var $full = $p.find('.review-text-full');

            if ($full.is(':visible')) {
                $full.hide();
                $short.show();
                $link.text('read more');
            } else {
                $short.hide();
                $full.show();
                $link.text('show less');
            }
        });
    }

    function showFallback() {
        $('#reviews-fallback').show();
        $('#reviews-loading').hide();
    }

    // =================================================================
    // FETCH
    // =================================================================

    function fetchReviews() {
        $('#reviews-loading').show();

        $.ajax({
            url: REVIEWS_API_URL,
            type: 'GET',
            dataType: 'json',
            timeout: 10000,
            success: function(data) {
                $('#reviews-loading').hide();

                if (!data || !data.reviews || data.reviews.length === 0) {
                    showFallback();
                    return;
                }

                var filtered = data.reviews.filter(function(r) {
                    return r.rating >= MIN_RATING;
                });

                if (filtered.length === 0) {
                    showFallback();
                    return;
                }

                setCachedReviews(filtered);
                renderReviews(filtered);
            },
            error: function() {
                $('#reviews-loading').hide();
                showFallback();
            }
        });
    }

    // =================================================================
    // INIT
    // =================================================================

    $(function() {
        // No API URL configured — hide section entirely
        if (!REVIEWS_API_URL) {
            $('#reviews').hide();
            return;
        }

        var cached = getCachedReviews();
        if (cached && cached.length > 0) {
            renderReviews(cached);
        } else {
            fetchReviews();
        }
    });

})(jQuery);
